import { render } from "./ForCreatorsComponent.vue?vue&type=template&id=64ce50e1&scoped=true"
import script from "./ForCreatorsComponent.vue?vue&type=script&lang=js"
export * from "./ForCreatorsComponent.vue?vue&type=script&lang=js"

import "./ForCreatorsComponent.vue?vue&type=style&index=0&id=64ce50e1&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64ce50e1"]])

export default __exports__